import { Injectable } from '@angular/core';
import {
  AlertController,
  LoadingController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  constructor(
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private alertController: AlertController,
    private translate: TranslateService,
    public platform: Platform
  ) {}

  async showLoading() {
    const loading = await this.loadingCtrl.create({
      cssClass: 'custom-loading',
      duration: 5000,
    });

    loading.present();
  }

  async dismissLoading() {
    this.loadingCtrl.dismiss();
  }

  async presentToast(
    message: string,
    position: 'top' | 'middle' | 'bottom' = 'top',
    color: string = null,
    duration: number = 3000
  ) {
    const toast = await this.toastController.create({
      message: message,
      color: color,
      duration: duration,
      position: position,
      buttons: [
        // {
        //   text: 'Close',
        //   role: 'cancel'
        // }
      ],
    });

    await toast.present();
  }

  async confirmPopup(header: string = 'Are you sure?', message: string = '') {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        header: header,
        mode: 'ios',
        message: message,
        cssClass: this.platform.is('desktop')
          ? 'publish-alert'
          : 'publish-alert cancel-alert',
        buttons: [
          {
            text: this.translate.instant('OWN_SHOP.GO_BACK'),
            cssClass: 'button-gray',
            handler: async () => {
              resolve(0);
            },
          },
          {
            text: this.translate.instant('OWN_SHOP.YES'),
            cssClass: 'new-product',
            handler: async () => {
              resolve(1);
            },
          },
        ],
      });
      await alert.present();
    });
  }

  async alertPopup(header: string = 'Are you sure?', message: string = '') {
    return new Promise(async (resolve) => {
      const alert = await this.alertController.create({
        header: header,
        mode: 'ios',
        message: message,
        cssClass: this.platform.is('desktop')
          ? 'publish-alert'
          : 'publish-alert cancel-alert',
        buttons: [
          {
            text: this.translate.instant('OWN_SHOP.OK'),
            cssClass: 'button-gray',
            handler: async () => {
              resolve(1);
            },
          },
          {
            text: this.translate.instant('OWN_SHOP.GO_BACK'),
            cssClass: 'new-product',
            handler: async () => {
              resolve(0);
            },
          },
        ],
      });
      await alert.present();
    });
  }
}
